import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import NovostiDetail from '../components/Novosti/NovostiDetail';

function NovostiPage () {
    return (
        <>
        <Navbar/>
        <NovostiDetail />
        <Footer />
        </>
    )
}
export default NovostiPage;